export default {
  logo: require('../assets/Logo.png'),
  icon: require('../assets/icon.png'),
  icon_dark: require('../assets/icon_dark.png'),
  detail_background: require('../assets/background.png'),
  artwork: require('../assets/noauth_image.png'),
  default_profile: require('../assets/default-image.png'),
  empty_set: require('../assets/empty-set.png')
}